"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const school = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        getSchoolSeatsOverview: async (schoolId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/seatsOverview`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getSchoolInvoiceDownloadLink: async (schoolId, invoiceId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/invoices/${invoiceId}/file`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getSchoolInvoices: async (schoolId, page = 1, pageSize = 10) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/invoices`;
            const response = await httpClient.get(endpoint, {
                query: { page, pageSize },
            });
            return response.data;
        },
        getSchoolTeachers: async (schoolId, page = 1, pageSize = 10, search = '', refreshCache = false) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers`;
            const response = await httpClient.get(endpoint, {
                query: { page, pageSize, search, refreshCache },
            });
            return response.data;
        },
        addTeacher: async (schoolId, payload) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        removeTeacher: async (userId, schoolId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/${userId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        removeSchoolAdmin: async (userId, schoolId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins/${userId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        assignSchoolAdmin: async (userId, schoolId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins`;
            const response = await httpClient.put(endpoint, {
                payload: { userId },
            });
            return response.data;
        },
        createSchoolAdmin: async (data) => {
            const endpoint = `${url}/${defaultVersion}/schools/${data.schoolId}/admins`;
            const payload = {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
            };
            const response = await httpClient.post(endpoint, { payload });
            return response.data;
        },
        upgradeSubscription: async (schoolId, accountNumber, newLicenceId, subscriptionId, userId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/upgrade`;
            const response = await httpClient.post(endpoint, {
                payload: {
                    accountNumber,
                    newLicenceId,
                    subscriptionId,
                    userId,
                },
            });
            return response.data;
        },
        resendInvitation: async (schoolId, userId, licenceModelId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/resendInvitation`;
            const response = await httpClient.post(endpoint, {
                payload: { userId, licenceModelId },
            });
            return response.data;
        },
        resetPassword: async (schoolId, email) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/resetPassword`;
            const response = await httpClient.post(endpoint, {
                payload: { email },
            });
            return response.data;
        },
        getSchoolAdmins: async (schoolId) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/admins`;
            const response = await httpClient.get(endpoint);
            return response.data;
        },
        getMoreSeats: async (data) => {
            const endpoint = `${url}/${defaultVersion}/schools/${data.schoolId}/getMoreSeats`;
            const payload = { seatsCount: data.seatsCount };
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        requestUpgradeProducts: async (schoolId, requestedProducts) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/requestUpgradeProducts`;
            const response = await httpClient.post(endpoint, {
                payload: {
                    requestedProducts,
                },
            });
            return response.data;
        },
        updateTeacherInfo: async (id, schoolId, payload) => {
            const endpoint = `${url}/${defaultVersion}/schools/${schoolId}/teachers/${id}`;
            const response = await httpClient.put(endpoint, {
                payload,
            });
            return response.data;
        },
    };
};
exports.default = school;
